<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText2"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
  /* eslint-disable */
  import Header from "@/components/header/";
  import Nav from "@/components/nav/";
  import Copy from "@/components/copy/"
  import Breadcrumb from "@/components/breadcrumb/"
  import Contact from "@/components/contact/";
  export default {
    data () {
      return {
        richText2: '',
      };
    },
    mounted () {
      this.richText2 = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">电镜 - 影像中心</span></p>'
        + '<p>&nbsp;</p>'

        + '<div id="left" style="float:left ; width:65%; height:100%;">'
        + '<p style="margin-bottom : 20px; margin-right : 20px;text-align: justify;line-height: 300%"><span style="margin-left: 36px; font-size: 16px">电镜 - 影像中心目前拥有 50 台(套)高精尖、跨学科的大型仪器、辅助制样及前处理设备，20名(不包括兼职人员)技术人员，其中博士学历11名，硕士学历9名，高级职称2名。依托先进的多尺度多维度多模态平台，可提供纳米-厘米级微区观察和成分分析，微纳米力学、磁学、电学和光学等物理性能表征，FIB切片等复杂样品制备，大样品原位加载(变温 / 拉伸 / 压缩)三维成像，亚细胞、细胞及组织水平二维及三维成像、活体小动物光声及光学成像等分析测试服务。</span></p>'
        + '</div>'

        + '<div id="right" style="float:left ; width:35%; height:100%;">'
        + '<p style="margin-left : 120px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/yanhuazhu.jpg" style="float: left; width: 180px; margin-right: 170px; margin-top:20px;" border="0" vspace="0" alt=""></p>'
        + '<p style="margin-left: 130px;text-align: justify"><span style="font-size: 16px;"><b>负责人：朱燕华</b></span></p>'
        + '</div>'
        + '<p>&nbsp;</p>'

        + '<div>'
        + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;透射电镜分析系统&nbsp;&nbsp;&nbsp; </span></p>'
        + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">关键设备：场发射透射电子显微镜、X射线显微镜、常温/冷冻超薄切片机。</span></p>'
        + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">支撑服务：物质超微结构解析、电子衍射分析、生物大分子三维结构解析。</span></p>'

        + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;&nbsp;扫描电镜分析系统 &nbsp;&nbsp;&nbsp;</span></p>'
        + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">关键设备：场发射扫描电子显微镜、聚焦离子束-扫描电镜、材料制样系统。</span></p>'
        + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">支撑服务：微观形貌分析、元素分析、晶体结构取向分析、聚焦离子束加工。</span></p>'

        + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;原子力显微镜分析系统&nbsp;&nbsp;&nbsp; </span></p>'
        + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">关键设备：生物快速原子力显微镜、环境可控原子力显微镜。</span></p>'
        + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">支撑服务：微纳米尺度物质的结构和形貌表征，力、电、磁等性能表征。</span></p>'

        + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;&nbsp;分子影像分析系统&nbsp;&nbsp;&nbsp;</span></p>'
        + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">关键设备：激光共聚焦显微镜、小动物核磁共振成像、小动物PET/CT成像。</span></p>'
        + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">支撑服务：分子、细胞、组织、活体等的结构、功能、生理的二维/三维影像。</span></p>'

        + '<p style="text-align: center;"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/electron_microscopy_imaging_en_1.jpg" style="float: left; width: 800px; " border="0" vspace="0" ></p>'

        + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
        + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">联系人</span></p>'
        + '<p style="text-align: left; "><span style="font-size: 16px; ">朱燕华</span></p>'
        + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: zhuyanhua@sjtu.edu.cn</span></p>'
        + '<p style="text-align: left; "><span style="font-size: 16px; ">Tel: +86-021-34208498-6204</span></p>'

        + '</div>'

        + '<p>&nbsp;</p><p>&nbsp;</p>'
    },
    components: {
      "v-header": Header,
      "v-nav": Nav,
      "v-copy": Copy,
      "v-breadcrumb": Breadcrumb,
      "v-contact": Contact,
    }
  };
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
      @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
  }
  .b-richtext {
    text-align:left;
    b,
    strong {
      font-weight: 700;
    }
    p {
      margin: 0 0 10px;
      line-height: 24px;
    }
    line-height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Service16/index.vue